var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNextActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.004,
    height: 9.945,
    viewBox: "0 0 6.004 9.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_next_active",
    d: "M5,0a1,1,0,0,0-.71.29l-4,4a1,1,0,0,0,1.42,1.42L5,2.41,8.294,5.7A1,1,0,0,0,9.7,4.29l-4-4A1,1,0,0,0,5,0Z",
    transform: "translate(6.004) rotate(90)",
    fill: "#0d6efd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNextActive);
export default __webpack_public_path__ + "static/media/ic_next_active.f2522249402606916bc25018030fc48f.svg";
export { ForwardRef as ReactComponent };